import { FETCH_JOBS_SEARCH_RESULTS } from "../../../../../graphql/query/Job";
import { jobFilterStore } from "../../../components/useJobsFilters";

const SearchedJobs = props => {
  const tableProps = {
    dataKey: "jobsV2",
    FETCH_QUERY: FETCH_JOBS_SEARCH_RESULTS,
    limit: 50,
    variables: {
      ...jobFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedJobs;
